import { useState, useEffect, useCallback, useMemo } from 'react';
import { solicitudesApi } from '../../services/api';
import { getSocket } from '../../services/socket';
import { Solicitud } from '../../objetos/Solicitud/objeto_solicitud';
import { useUsers } from '../../metodos/userContext';
import { Cotizacion } from '../../objetos/Solicitud/objeto_solicitud';
import { useLoading } from '../../utils/LoadingProvider';
import { toast } from 'react-toastify';
import { useRetornoAsesor } from '../../config/unificacion';
import { useDialog } from '../../components/Dialogs/Dialogprovider';

export const useDetalleSolicitudModel = () => {
    const [solicitud,setSolicitud] = useState();
    const [loadingSolicitudes, setLoading] = useState(true);
    const [errorSolicitudes, setError] = useState(null);
    const {usuario, loading, error } = useUsers();
    const { withLoading } = useLoading();
    const {retornoAsesor} = useRetornoAsesor();
    const cambiadopor = retornoAsesor();

    const { showSuccess, showError, showConfirm } = useDialog();

    // Estado para el diálogo de confirmación
    const [confirmDialog, setConfirmDialog] = useState({
      isOpen: false,
      message: '',
      onConfirm: null
    });
    const showConfirmDialog = (message, onConfirmFn) => {
      setConfirmDialog({
          isOpen: true,
          message,
          onConfirm: onConfirmFn
      });
    };
    // Cerrar diálogo de confirmación
    const closeConfirmDialog = () => {
      setConfirmDialog({
          isOpen: false,
          message: '',
          onConfirm: null
      });
    };

    //añadir cotizacion
    const [nuevaCotizacion, setNuevaCotizacion] = useState({
        cotizacion: '',
        nombretutor: '',
        comentariocotizacion: '',
    });

    //crear nueva cotizacion
    const addNewCotizacion = async(nombreEmpresa, valorCotizacion, comentarioCotizacion,idSolicitud,nombreTutorLocal = '') => {
      return withLoading(async () =>{
        //Inicializar variables
      const cotizacionValue = valorCotizacion !== undefined ? Number(valorCotizacion) : Number(nuevaCotizacion.cotizacion);
      const comentarioValue = comentarioCotizacion !== undefined ? comentarioCotizacion : nuevaCotizacion.comentariocotizacion;
      const solicitudId = idSolicitud || solicitud.id; // Usar el ID proporcionado o el del estado

      // Validaciones
      let errores = [];
      console.log("añadiendo cotizacion", nombreEmpresa,cotizacionValue,comentarioValue,solicitudId);
      
      // Validar cotización: no puede ser menor a 0, pero puede ser -1
      if (isNaN(cotizacionValue)) {
          errores.push("El valor de la cotización debe ser un número");
      } else if (cotizacionValue < 0 && cotizacionValue !== -1) {
          errores.push("La cotización no puede ser menor a 0 ");
      }
      
      // Validar uidtutor y nombretutor
      if (!usuario.uid || usuario.uid.trim() === '') {
          errores.push("El ID del tutor no puede estar vacío");
      }
      
      if (!usuario.nombrewhatsapp || usuario.nombrewhatsapp.trim() === '') {
          errores.push("El nombre del tutor no puede estar vacío");
      }
      
      // Si hay errores, mostrarlos y detener el proceso
      if (errores.length > 0) {
        toast.error("Por favor corrige los siguientes errores:\n" + errores.join("\n"));
        return;
      }
      
      try {
          console.log("ha pasar datos");
          //corroborar que el precio sea un int
          const cotizacionObj = new Cotizacion({
              cotizacion: cotizacionValue,
              uidtutor: usuario.uid,
              nombretutor: nombreTutorLocal === "" ? usuario.nombrewhatsapp : nombreTutorLocal, // ✅ Invertido
              comentariocotizacion: comentarioValue,
              fechaconfirmacion: new Date()
          });
          
          const cotizacionJSON = cotizacionObj.toJson();
          
          const respuesta = await solicitudesApi.addCotizacion(solicitudId, nombreEmpresa, cotizacionJSON, cambiadopor)
          
          // Solo actualizar el estado si estamos usando los valores del estado
          if (valorCotizacion === undefined && comentarioCotizacion === undefined) {
              setNuevaCotizacion({
                  cotizacion: '',
                  comentariocotizacion: ''
              });
          }
          
          // Usamos la respuesta para mostrar un mensaje apropiado
          if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }
          
      } catch(error) {
          console.error('Error al añadir cotizacion:', error);
          toast.error("Ocurrió un error en la cotización: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
      }
      },'Procesando Cotizacion...');
      
    }

    //Eliminar cotizacion
    const deleteCotizacion = async(nombreEmpresa,id,cotizacionData) =>{

      return withLoading(async () =>{

        try{

          const respuesta = await solicitudesApi.deleteCotizacion(nombreEmpresa,id,cotizacionData,cambiadopor);

          if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }

        }catch(error){
          console.error('Error al eliminar cotizacion:', error);
          toast.error("Ocurrió un error en al eliminar cotizacion: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }

      }, 'Porcesando Eliminacion de cotizacion...')

    }

    //rechazar solicitud
    const rechazarSolicitud = async(nombreEmpresa,idSolicitud) => {
      showConfirmDialog(
        "¿Estás seguro que deseas rechazar esta solicitud?",
        async () => {
          console.log("ejecutnaod ")
          closeConfirmDialog();
          addNewCotizacion(nombreEmpresa, -1, "NO_PUEDO",idSolicitud);
        }
      );
    }

    //input cotizacion
    const handleInputChangeCotizacion = useCallback((e) => {
        const { name, value } = e.target;
        console.log("cambios en cotizacion", name, value);
        
        setNuevaCotizacion(prevState => {
            let finalValue = value;
            
            if (name === 'cotizacion') {
                finalValue = value.replace(/[^0-9]/g, '');
            }
            
            return {
                ...prevState,
                [name]: finalValue
            };
        });
    }, []);

    //cargar solciitud por ID
    const cargarSolicitudPorId = useCallback(async (id, nombreEmpresa) => {
        // Evitar cargar la misma solicitud repetidamente
        if (solicitud && solicitud.id === id) {
          return solicitud; // Retorna la solicitud existente si ya está cargada
        }
        
        try {
          setLoading(true);
          console.log("Obteniendo solicitud:", id, nombreEmpresa);
          const data = await solicitudesApi.getSolicitudPorId(id, nombreEmpresa);
          
          // Crear instancia de Solicitud
          const solicitudObj = Solicitud.fromJson(data, id);
          setSolicitud(solicitudObj);
          setError(null);
          return solicitudObj;
        } catch (error) {
          console.error("Error al obtener solicitud:", error);
          setError(error.message || "Error al cargar la solicitud");
          return null;
        } finally {
          setLoading(false);
        }
    },[]);

    //añadir nueva solciitud
    const addNewSolicitud = async (nombreEmpresa, solicitudData) => {   
      
      return await withLoading(async () => {
        try {
          console.log("Añadiendo nueva solicitud");
          
          console.log("la solicitud data",solicitudData);
          const solicitudInstance = new Solicitud(solicitudData);
          const solicitudMap = solicitudInstance.toMap();

          console.log("soplciitud map",solicitudMap);
          
          
          // Procesar archivos si existen, solo cuando se tiene contenido enriquecido
          let archivosExtraidos = [];
          if (solicitudData.contenidoEnriquecido) {
            const resultado = await processFilesForUpload(solicitudData.contenidoEnriquecido);
            console.log("resultado contenido",resultado.contenido)
            solicitudMap.contenidoEnriquecido = resultado.contenido;
            archivosExtraidos = resultado.archivos;
          }

          console.log("contenido",solicitudData.contenidoEnriquecido)
          
          // Llamar a la nueva función que maneja multer
          const respuesta = await solicitudesApi.addSolicitud(nombreEmpresa, solicitudMap, archivosExtraidos);

          if(respuesta.success){
            toast.success(respuesta.message);
            showSuccess(respuesta.message);
          }else{
            toast.error(respuesta.message);
            showError(respuesta.message);
          }
          
          return { success: true, data: respuesta.data };
          
        } catch (error) {
          console.error('Error interno:', error);
          showError("respuesta.message");
          toast.error(error);
          throw error;
        }
      }, 'Añadiendo nueva solicitud...');
    };

    //field
    //array
    //array_insert
    //actualizar informacion de solicitud
    const actualizarSolicitud = async(id,nombreEmpresa,field,valor,type = 'field',ultCambio = "") =>{
      return withLoading(async () =>{
        console.log("valores",id,nombreEmpresa,field,valor,type,ultCambio);
        let finalUpdateData = {};
        //validar que fiel no sea nulo
        if(!field ){
          toast.error("Este error no deberia salir");
          return;
        }
        
        if(type == "field" ){
          const datosParaValidar = { [field]: valor };
          const solicitudTemporal = new Solicitud({});
          solicitudTemporal.updateFromJson(datosParaValidar);
          console.log("la sol temporarl",solicitudTemporal);
          const valorConvertido = solicitudTemporal.getFieldValue(field);
          console.log("el valor convertido",valorConvertido);

          finalUpdateData = {
              [field]: valorConvertido
            };
        }
        else if(type == "array"){
          console.log("el field es",field);
          const campoAnidado = field;
            const [parteIzquierda, parteDerecha] = campoAnidado.split('.');
            const datosParaValidar = { [parteDerecha]: valor.value };
            const cotizacionTemporal = new Cotizacion({});
            cotizacionTemporal.updateFromJson(datosParaValidar);
            console.log("cotizacion temporal",cotizacionTemporal);
            const valorConvertido = cotizacionTemporal.getFieldValue(parteDerecha);

            finalUpdateData = {
                          "field" : parteIzquierda,
                          "elementId": valor.elementId,
                          "data": {
                            [parteDerecha] : valorConvertido,
                          }
            }

            console.log("tenemos final update cotizaciones",finalUpdateData);
        }
        else if(type == "array_insert"){
          finalUpdateData = {             
              field: field,             
              data: valor // valor será el array completo de preguntas actualizado
            }
        }

        try{
          console.log("datos",id,nombreEmpresa,field,valor, type,finalUpdateData);
                    
          const respuesta = await solicitudesApi.updateSolicitud(id,nombreEmpresa,finalUpdateData,type,cambiadopor);

          if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }

        }
        catch(error){
          console.error('Error al actualizar solicitud', error);
          toast.error("Ocurrió un error a actualizar la solicitud: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }


      },'Actualizando solicitud');
    }
  
    //actualizar contenido enriquecido
    const actualizarContenidoEnriquecido = async(id,nombreEmpresa,contenidoEnriquecido) =>{
      return await withLoading(async () =>{

        try{
          let archivosExtraidos = [];
          const resultado = await processFilesForUpload(contenidoEnriquecido);
          console.log("contenido enriquecido revisando",contenidoEnriquecido);
          archivosExtraidos = resultado.archivos;

          const respuesta = await solicitudesApi.updateContenidoEnriquecido(id,nombreEmpresa,resultado.contenido,archivosExtraidos,cambiadopor);

          return { success: true, data: respuesta.data };
        }
        catch(error){
          console.error('Error Al actualizar contenido enriquecido:', error);
          throw error;
        }

      },'Actualizando solicitud');
    }

    //notificar solicitud
    const enviarNotificacionSolciitud = async(solicitudLocal) =>{
      return withLoading(async () =>{

        try{
          const solicitudInstance = new Solicitud(solicitudLocal);
          const solicitudMap = solicitudInstance.toNotify();

          const respuesta = await solicitudesApi.notificarSolicitud(solicitudMap);

          if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }
        }
        catch(error){
          console.error('Error al notificar solicitud', error);
          toast.error("Ocurrió un error a notificar la solicitud: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }

      },'Enviando notificacion')
    }

    const setupWebSocketsSolicitudes = (solicitudObjeto,nombreEmpresas) => {
      if (!solicitudObjeto) return; // Salir si no hay solicitud

        const socket = getSocket();

        console.log("tenemos solicitud en webSocket",solicitudObjeto.id);

        // Listener para actualizaciones específicas de esta solicitud
        const handleSolicitudUpdate = async ({ id,originalId}) => {
          console.log(`Recibida actualización de la solicitud ${id} - ${originalId}`);
          
          const globalIdNotificacion = originalId;
          const originalIdNotificacion = id;

          console.log('Notificación coincide. Recargando datos por HTTP...');

          const data = await solicitudesApi.getSolicitudPorId(solicitudObjeto.id, nombreEmpresas);
          const solicitudActualizada = Solicitud.fromJson(data, id);

          if (solicitudObjeto !== null && solicitudObjeto !== undefined) {
            if (originalId.toString() === solicitudObjeto.id.toString()) {
              setSolicitud(solicitudActualizada);
            }
          }

         
        };
    
       
        if (solicitudObjeto !== null && solicitudObjeto !== undefined) {
          console.log("vamos a escuchar la solicitud");

          socket.emit('join-solicitud', { id: solicitudObjeto.id, nombreEmpresa: nombreEmpresas });
    
          // Registrar los listeners
          socket.on('solicitud:id', handleSolicitudUpdate);    
    
        }
          
        // Función de limpieza para cuando el componente se desmonte
        return () => {
          // Dejar de escuchar esta solicitud
          socket.emit('leave-solicitud', { id: solicitudObjeto.id, nombreEmpresa: nombreEmpresas });
          // Eliminar los listeners
          socket.off('solicitud:id', handleSolicitudUpdate);
          //socket.off('solicitud:delete', handleSolicitudDelete);
        };
    };

    //Procesar solicitud - CORREGIDO
    const processFilesForUpload = async (contenidoQuill) => {
      if (!Array.isArray(contenidoQuill)) {
        console.log("❌ NO ES ARRAY - retornando original");
        return { contenido: contenidoQuill, archivos: [] };
      }

      const archivosExtraidos = [];
      const nombresUsados = []; // Para evitar duplicados
      const contenidoModificado = [...contenidoQuill]; // Copia del contenido para modificar

      // 🔄 Extraer archivos Y normalizar SOLO nombres en el contenido
      for (let i = 0; i < contenidoModificado.length; i++) {
        const item = contenidoModificado[i];
        console.log(`\n🔍 PROCESANDO ITEM ${i}:`);
            
        if (item.insert && typeof item.insert === 'object' && item.insert.archivoOffline) {
          console.log("✅ ENCONTRÓ archivoOffline!");
          const archivoData = item.insert.archivoOffline;
          console.log("archivoData:", archivoData);
                
          try {
            let file = null;
            
            // NORMALIZAR EL NOMBRE DEL ARCHIVO
            const nombreOriginal = archivoData.nombre || archivoData.fileName || 'archivo_sin_nombre';
            const nombreNormalizado = obtenerNombreUnico(nombreOriginal, nombresUsados);
            nombresUsados.push(nombreNormalizado);
            
            console.log(`🔄 NORMALIZANDO NOMBRE: "${nombreOriginal}" → "${nombreNormalizado}"`);
            
            // MÉTODO 1: Si tiene blob URL (formato anterior)
            if (archivoData.urlArchivo && archivoData.urlArchivo.startsWith('blob:')) {
              console.log("🔄 PROCESANDO BLOB URL");
                        
              const response = await fetch(archivoData.urlArchivo);
              const blob = await response.blob();
                        
              file = new File([blob], nombreNormalizado, {
                type: archivoData.fileType
              });
                        
              console.log("✅ File creado desde blob:", file.name, file.size);
            }
            // MÉTODO 2: Si tiene base64 (formato actual)
            else if (archivoData.contenido && archivoData.nombre) {
              console.log("🔄 PROCESANDO BASE64");
              console.log("Nombre original:", archivoData.nombre);
              console.log("Nombre normalizado:", nombreNormalizado);
              console.log("Tipo:", archivoData.tipo);
              console.log("Base64 length:", archivoData.contenido.length);
                        
              // Convertir base64 a Blob
              const base64Data = archivoData.contenido;
              const byteCharacters = atob(base64Data);
              const byteNumbers = new Array(byteCharacters.length);
                        
              for (let j = 0; j < byteCharacters.length; j++) {
                byteNumbers[j] = byteCharacters.charCodeAt(j);
              }
                        
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: archivoData.tipo });
                        
              // Crear File object con nombre normalizado
              file = new File([blob], nombreNormalizado, {
                type: archivoData.tipo
              });
                        
              console.log("✅ File creado desde base64:", file.name, file.size);
            }
            else {
              console.log("❌ Formato de archivo no reconocido");
              console.log("Keys disponibles:", Object.keys(archivoData));
            }
                    
            if (file) {
              archivosExtraidos.push(file);
              
              // 🎯 MODIFICAR SOLO EL NOMBRE: mantener todas las demás propiedades intactas
              contenidoModificado[i] = {
                ...item,
                insert: {
                  ...item.insert,
                  archivoOffline: {
                    ...archivoData, // ← MANTENER TODAS las propiedades originales
                    nombre: nombreNormalizado, // ← Solo cambiar el nombre
                    fileName: nombreNormalizado // ← Y fileName si existe
                  }
                }
              };
              
              console.log("✅ ARCHIVO EXTRAÍDO Y SOLO NOMBRE ACTUALIZADO! Total:", archivosExtraidos.length);
              console.log("📝 Nombre actualizado en contenido:", nombreNormalizado);
              console.log("📝 Propiedades conservadas:", Object.keys(archivoData));
            }
                  
          } catch (error) {
            console.error('❌ Error procesando archivo:', error);
          }
        }
      }

      console.log("\n🎯 === RESULTADO FINAL ===");
      console.log("archivosExtraidos:", archivosExtraidos.length);
      console.log("contenido modificado:", contenidoModificado.length, "items");
      
      archivosExtraidos.forEach((archivo, index) => {
        console.log(`  [${index}]: ${archivo.name} (${archivo.size} bytes)`);
      });

      // Mostrar cambios en el contenido
      console.log("\n📝 === CAMBIOS EN CONTENIDO ===");
      contenidoModificado.forEach((item, index) => {
        if (item.insert && item.insert.archivoOffline) {
          const archivo = item.insert.archivoOffline;
          console.log(`  [${index}]: Nombre actualizado a "${archivo.nombre}"`);
          console.log(`  [${index}]: Propiedades conservadas:`, Object.keys(archivo));
        }
      });

      // ✅ RETORNAR: archivos extraídos + contenido con SOLO nombres normalizados
      return {
        contenido: contenidoModificado,  // ← Contenido con SOLO nombres cambiados
        archivos: archivosExtraidos      // ← Archivos extraídos con nombres normalizados
      };
    };

    //normalizar archivos aca
    function normalizarNombreArchivo(fileName) {
      if (!fileName || typeof fileName !== 'string') {
        return 'archivo_sin_nombre';
      }

      // Separar nombre y extensión
      const lastDotIndex = fileName.lastIndexOf('.');
      let nombre = fileName;
      let extension = '';
      
      if (lastDotIndex > 0) {
        nombre = fileName.substring(0, lastDotIndex);
        extension = fileName.substring(lastDotIndex);
      }

      // Normalizar el nombre (sin la extensión)
      let nombreNormalizado = nombre
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_\-]/g, '')
        .replace(/[-_]+/g, '_')
        .replace(/^[-_]+|[-_]+$/g, '');

      if (!nombreNormalizado) {
        nombreNormalizado = 'archivo';
      }

      const maxLength = 200 - extension.length;
      if (nombreNormalizado.length > maxLength) {
        nombreNormalizado = nombreNormalizado.substring(0, maxLength);
      }

      return nombreNormalizado + extension.toLowerCase();
    }

    //nombre unico de archivo
    function obtenerNombreUnico(fileName, existingNames = []) {
      let nombreNormalizado = normalizarNombreArchivo(fileName);
      
      if (!existingNames.includes(nombreNormalizado)) {
        return nombreNormalizado;
      }

      const lastDotIndex = nombreNormalizado.lastIndexOf('.');
      let nombre = nombreNormalizado;
      let extension = '';
      
      if (lastDotIndex > 0) {
        nombre = nombreNormalizado.substring(0, lastDotIndex);
        extension = nombreNormalizado.substring(lastDotIndex);
      }

      let contador = 1;
      let nombreConSufijo;
      
      do {
        nombreConSufijo = `${nombre}_${contador}${extension}`;
        contador++;
      } while (existingNames.includes(nombreConSufijo));

      return nombreConSufijo;
    }

    return {
        solicitud,
        loadingSolicitudes,
        errorSolicitudes,
        nuevaCotizacion,
        setupWebSocketsSolicitudes,
        
        // Métodos de utilidad adicionales que podrías necesitar
        cargarSolicitudPorId,
        handleInputChangeCotizacion,
        addNewCotizacion,
        rechazarSolicitud,
        deleteCotizacion,

        //actualziar solciitud
        actualizarContenidoEnriquecido,
        actualizarSolicitud,
        addNewSolicitud,

        //notificar
        enviarNotificacionSolciitud,

        //dialogos
        // Falta añadir estas propiedades:
        confirmDialog,       
        closeConfirmDialog,    
        showConfirmDialog,    
    };

}